import { httpClient } from 'core/net/http';

export const logout = async () => {
  return await httpClient.useInternalApi.asAuthorised().post('security/logout', {});
};
